angular.module('Itao.IndicatorMap').directive('settings', ['mapConfig', function(mapConfig) {
  'use strict';
  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'settings.html',
    scope: {
      types: '=',
      widgetConfig: '='
    },
    link: function (scope, element) {
      scope.toggleSettings = function(section, $event) {
        var gridItem = element.closest('.grid-stack-item-content'),
              sectionSettings = gridItem.find(".settings " + section);

        element.find(".settings-menu a").removeClass("settings-active");
        if(sectionSettings.hasClass('settings-active')) {
          sectionSettings.removeClass('settings-active');
        } else {
          gridItem.find(".settings > div").removeClass("settings-active");
          jQuery($event.currentTarget).addClass("settings-active");
          sectionSettings.addClass('settings-active');
        }
      };
      scope.goFullscreen = function() {
        scope.widgetConfig['fullscreen'] = true;
        jQuery('html').addClass('fullscreen');
        jQuery(element).closest('.grid-stack-item').addClass('fullscreen-on');
      };
      scope.endFullscreen = function() {
        scope.widgetConfig['fullscreen'] = false;
        jQuery('html').removeClass('fullscreen');
        jQuery(element).closest('.grid-stack-item').removeClass('fullscreen-on');
      };
      scope.$watch('widgetConfig.fullscreen', function () {
        if(scope.widgetConfig['fullscreen'] && !jQuery('html').hasClass('fullscreen')) {
          scope.goFullscreen();
        }
      });
    }
  };
}]);
